// config/seo.config.js
export const SITE_CONFIG = {
  name: "Top Orion",
  title: "Top Orion | Smart ERP Systems & Web Development",
  description: "Top Orion helps restaurants automate inventory and fitness trainers grow their business with custom SaaS solutions. Stop restaurant inventory leakage with our real-time tracking system.",
  keywords: "Inventory management for restaurants, Web development for fitness trainers, Stop restaurant inventory leakage, Live restaurant margin tracker, Fitness trainer booking system, Lead generation for fitness coaches, Restaurant ERP system, Fitness business management software, Top Orion",
  url: "https://toporion.net",
  image: "https://toporion.com/top-og.png",
  twitterHandle: "@toporion",
  author: "Salman Haider",
  organization: {
    name: "Top Orion Technologies",
    logo: "https://toporion.com/logo.png",
    sameAs: [
      "https://github.com/toporion",
      "https://linkedin.com/company/toporion"
    ]
  }
};

// Page-specific SEO configurations
export const PAGE_SEO = {
  home: {
    title: "Top Orion | Smart ERP Systems & Web Development for Restaurants & Fitness Trainers",
    description: "Transform your restaurant with real-time inventory tracking and prevent revenue leakage. Fitness trainers: Get a custom booking system and lead generation platform. Top Orion delivers tailor-made SaaS solutions.",
    keywords: "Restaurant inventory management, Fitness trainer web development, Restaurant ERP system, Inventory leakage prevention, Fitness booking software, Lead generation for trainers"
  },
  about: {
    title: "About Top Orion | Engineering Future-Ready Business Solutions",
    description: "Learn how Top Orion helps businesses automate operations. We specialize in restaurant inventory systems and fitness trainer platforms that drive real growth.",
    keywords: "About Top Orion, Business automation experts, Restaurant software developers, Fitness tech solutions"
  },
  services: {
    title: "Services | Custom ERP & Web Development by Top Orion",
    description: "Explore Top Orion's services: Restaurant inventory management systems, fitness trainer booking platforms, lead generation solutions, and custom web development.",
    keywords: "Custom ERP development, Restaurant software services, Fitness trainer website development, Lead generation systems"
  },
  contact: {
    title: "Contact Top Orion | Start Your Digital Transformation",
    description: "Ready to automate your restaurant or fitness business? Contact Top Orion for a free consultation on inventory management systems and custom web solutions.",
    keywords: "Contact Top Orion, Restaurant software consultation, Fitness tech consultation, ERP system inquiry"
  }
};